import config from '../../config'
import { tkHelper } from '@moke/vue-tk'
import axios from 'axios'
const tkPayment = {
  mokeId: '15920a19-54ef-4761-956a-2aaeed9386bf',
  mokesecret: '4b378d27-3500-44b4-9c9b-237c9fbe4a59',
  payCBM: null,
  // channel='WX_APP'微信，'ALI_APP'支付宝
  // message:三个参数
  // { channel:'WX_APP'微信或'ALI_APP'支付宝, title:string, fee:number正整数，单位分}
  // paycbm是callbackmessage，返回信息
  // 增加一个回传信息billno
  // 增加一个根据billno查询数据的方法
  creatOrder: async function (message, isMokeceshi, testApp) {
    let timestamp = Date.parse(new Date())
    let billno = message.id + 'MOKE' + timestamp
    // let appsign = isMokeceshi ? MD5(tkPayment.mokeId + timestamp + tkPayment.mokesecret) : MD5(tkPayment.appId + timestamp + tkPayment.appsecret)
    // let orderCorrespond = { WX_APP: 'wx' + timestamp, ALI_APP: 'al' + timestamp }
    // if (orderCorrespond.hasOwnProperty(message.channel)) {
    //   billno = orderCorrespond[message.channel]
    // } else { throw new Error('tkPayment: 未找到channel') }
    // 判断是否安装微信支付宝
    let ownapp = {
      WX_APP: {
        pname: 'com.tencent.mm',
        action: 'weixin://' },
      ALI_APP: {
        pname: 'com.eg.android.AlipayGphone',
        action: 'alipays://platformapi/startapp' }
    }
    if (!window.plus.runtime.isApplicationExist(ownapp[message.channel]) && testApp) {
      throw new Error('未安装支付app')
    }

    // let totalfee = isMokeceshi ? 1 : message.fee
    // let appid = isMokeceshi ? tkPayment.mokeId : tkPayment.appId

    // let rs = await tkAjax.post('https://api.mokekeji.com/curl', {
    //   url: 'https://api.beecloud.cn/2/rest/app/bill',
    //   method: 'post',
    //   data: {
    //     app_id: appid,
    //     channel: message.channel,
    //     title: message.title,
    //     total_fee: totalfee,
    //     bill_no: billno,
    //     app_sign: appsign,
    //     timestamp: timestamp
    //   }
    // }).catch(e => {
    //   throw e
    // })
    try {
      let rs = await axios.get(`${config.cloudUrl}/classes/order/${message.id}`)
      let res = {
        data: {
          data: rs.data.paydata
        }
      }
      return { rs: res, message: message, billno: billno }
    } catch (e) {
      console.log(JSON.stringify(e))
    }
  },
  pullPayment: function (res) {
    let rs = res.rs
    window.plus.payment.getChannels(successCB => {
      if (rs.data.data.hasOwnProperty('package')) {
        if (rs.data.data.package === 'Sign=WXPay') {
          let nowChannel = null
          let haswx = successCB.some(function (i) {
            if (i.id === 'wxpay') {
              nowChannel = i
              return true
            }
          })
          if (haswx) {
            let paySrc = JSON.stringify(rs.data.data)
            window.plus.payment.request(nowChannel, paySrc, successF => { tkPayment.payCBM = { success: successF, message: res.message, billno: res.billno } },
              errorF => {
                tkPayment.payCBM = { error: errorF }
              })
          }
        }
      } else if (rs) {
        let nowChannel = null
        let hasali = successCB.some(function (i) {
          if (i.id === 'alipay') {
            nowChannel = i
            return true
          }
        })
        if (hasali) {
          let paySrc = rs.data.data.order_string
          window.plus.payment.request(nowChannel, paySrc, successF => { tkPayment.payCBM = { success: successF, message: res.message } }, errorF => { tkPayment.payCBM = { error: errorF } })
        }
      }
    }, errorCB => { Promise.reject(new Error(errorCB)) })
  },

  create: async function (message, testApp = true) {
    if (!window.plus) {
      // 是否是develop状态的同时是否是localhost
      if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
        // 开发模式直接返回成功
        return Promise.resolve('开发模式,返回成功')
      }
      return Promise.reject(new Error('没有app环境'))
    }
    // 是plus环境时,正常支付判断初始化
    let rs = await tkPayment.creatOrder(message, false, testApp).catch(e => Promise.reject(new Error(e)))
    if (!rs) return Promise.reject(new Error('网络出错'))
    try {
      await tkPayment.pullPayment(rs)
    } catch (e) {
      console.log(e, '出错')
      return Promise.reject(new Error(e))
    }
    while (!tkPayment.payCBM) {
      await tkHelper.sleep(300)
    }
    let cbm = JSON.stringify(tkPayment.payCBM)
    if (tkPayment.payCBM.hasOwnProperty('success')) {
      tkPayment.payCBM = null
      return Promise.resolve(cbm)
    } else if (tkPayment.payCBM.hasOwnProperty('error')) {
      tkPayment.payCBM = null
      return Promise.reject(new Error(cbm))
    }
  }
}

export default tkPayment
